import { JobSeekerPaymentInfos } from './employment.model';

export class ApprovalRequest {
    jobSeekerPaymentInfo: JobSeekerPaymentInfos
}


